import { createFileRoute, redirect } from '@tanstack/react-router';

import { redirectToVehicles } from './-redirect';

/**
 * Legacy path. The list moved from `/fleet-management/digital-vehicle-files` to
 * `/fleet-management/vehicles`; this keeps old bookmarks and links working.
 * Safe to delete once those have aged out.
 */
export const Route = createFileRoute('/_app/fleet-management/digital-vehicle-files/')({
  beforeLoad: ({ location }) => {
    throw redirect(redirectToVehicles(location.href));
  },
});
